import { UseFormReturnType } from '@mantine/form';
import { useMemo } from 'react';

import { TSDViewHouseFormValues } from '@e-origin/contracts';
import { DocumentsEnum } from '@e-origin/shared';

import { Documents } from '@components';
import { TSDDocumentFormSchema } from '../../TSDDocumentFormSchema';

interface HouseDocumentsProps {
  houseForm: UseFormReturnType<TSDViewHouseFormValues>;
  disabled: boolean;
}

export const HouseDocuments: React.FC<HouseDocumentsProps> = ({ houseForm, disabled }) => {
  const documentFormSchema = TSDDocumentFormSchema();

  const documents = useMemo(
    () => ({
      transportDocuments: [...houseForm.values.transportDocuments],
      previousDocuments: [...houseForm.values.previousDocuments],
      additionalInformation: [...houseForm.values.additionalInformation],
      supportingDocuments: [...houseForm.values.supportingDocuments],
    }),
    [houseForm.values],
  );

  const handleDocumentDelete = (documentType: DocumentsEnum, documentIndex: number) => {
    houseForm.setFieldValue(`${documentType}`, [...(houseForm.values[documentType] || []).filter((_, idx) => idx !== documentIndex)]);
  };

  const handleSavingDocument = (savedDocument: any) => {
    if (savedDocument.docIndex >= 0) {
      const updatedDocuments = houseForm.values[savedDocument.type].map((doc, idx) => {
        if (idx === savedDocument.docIndex) {
          return savedDocument.data;
        }
        return doc;
      });
      houseForm.setFieldValue(`${savedDocument.type}`, updatedDocuments);
    } else {
      houseForm.setFieldValue(`${savedDocument.type}`, [...(houseForm.values[savedDocument.type] || []), savedDocument.data]);
    }
  };

  return (
    <Documents
      disabledDocuments={[DocumentsEnum.ADDITIONAL_REFERENCE]}
      documents={documents}
      onDelete={handleDocumentDelete}
      onSave={handleSavingDocument}
      disabled={disabled}
      documentFormSchema={documentFormSchema}
    />
  );
};
